import React from 'react';
import { connect } from 'react-redux';
import * as adsActions from '../../store/ads/actions';
import * as reducers from '../../store/reducers';
import Hero from 'Containers/Hero';

function BookPageHero({ adCampaign, adCampaignKey }) {
  return <Hero hero={adCampaign} sponsored={false} id={adCampaignKey} />;
}

const mapStateToProps = (state, { adCampaignKey }) => ({
  adCampaign: reducers.getAdCampaign(state, adCampaignKey),
});

export default connect(mapStateToProps, adsActions)(BookPageHero);
